export function media(str) {
    return (str) ? str.replace('/media/', '') : false;
}